import Badge from "components/Badge";
import Tooltip from "components/Tooltip";

const simpleNumberFormatter = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 3,
});

function isNumber(input: string | number) {
  return !isNaN(+Number(input));
}

function formatValue(v: string | number): string | number {
  return isNumber(v) ? simpleNumberFormatter.format(v as number) : v;
}

interface ChipCellProps {
  value: string[] | number[] | string | number;
}

function renderBadges(values: (string | number)[]) {
  return values.map((v, i) => (
    <Badge type="auto" key={i} className="!h-[23px]">
      {formatValue(v)}
    </Badge>
  ));
}

export default function ChipCell({ value }: ChipCellProps) {
  const arrayValue = Array.isArray(value) ? value : [value];

  if (arrayValue.length <= 1) {
    return (
      <div className="flex [flex-direction:inherit] gap-1">
        {arrayValue.length ? renderBadges(arrayValue) : "-"}
      </div>
    );
  }

  return (
    <Tooltip
      content={
        <div className="flex flex-col gap-1 p-1">
          {renderBadges(arrayValue)}
        </div>
      }
      truncate
      whiteTheme
      disableStickOnHover
      className="flex [flex-direction:inherit] gap-1"
    >
      {renderBadges(arrayValue)}
    </Tooltip>
  );
}
